import React, { useEffect, useRef, useState } from "react";

// replace these imports with your actual paths
import comp3_1 from "../../Images/img/Component 3-1.png";
import svgMargin from "../../Images/img/SVG_margin.png";
import aiRobot from "../../Images/img/ai-robot.webp";
import { HiArrowRight } from "react-icons/hi";
import comp2_4 from "../../Images/img/Component 2-4.png";
import comp2_7 from "../../Images/img/Component 2-7.png";
import comp2_3 from "../../Images/img/Component 2-3.png";
import comp3_2 from "../../Images/img/Component 3-2.png";
import comp16_10 from "../../Images/img/Component 16-10.png";
import { Link } from "react-router-dom";
import comp3_3 from "../../Images/img/Component 3-3.png";
import container1 from "../../Images/img/Container1.png";
import { ArrowRight } from "lucide-react";
import counter1 from "../../Images/img/Component 16-11.png";
import counter2 from "../../Images/img/Component 16-12.png";
import counter3 from "../../Images/img/Component 16-13.png";
import counter4 from "../../Images/img/Component 16-14.png";
import useInViewOnce from "./useInViewOnce";
const HeroSection = () => {
  return (
    <div className="hero1 ">
      <div className="w-[90%] 2xl:w-[70%] mx-auto px-4 pt-12">
        {/* Row */}
        <div className="flex flex-wrap items-center">
          {/* Left */}
          <div className={`w-full lg:w-1/2 `}>
            <div className="main-heading1 ">
              <h1 className="mt-4 h1-mb h1-md h1-lg h1-2xl">
                Webdesign für{" "}
                <span className="relative inline-block md:mt-4 md:mb-2">
                  <span className="relative inline-block">
                    <span className="easiest-badge !text-[#0b2b40]">mehr</span>

                    {/* small accent lines */}
                    <span className="absolute -top-2 -right-2 h-2 w-2 rotate-12 rounded-full bg-lime-300" />
                    <span className="absolute -top-3 right-3 h-3 w-[2px] rotate-12 bg-lime-300" />
                  </span>
                </span>{" "}
                Sichtbarkeit & Conversions.
              </h1>

              <p
                className="mt-6 md:text-xl leading-6 text-[#163949]/70"
                data-aos="fade-right"
                data-aos-duration="900"
              >
                Wir entwickeln maßgeschneiderte Webseiten, die nicht nur gut
                aussehen, sondern messbar mehr Anfragen und Umsatz generieren.
                Keine Templates. Kein Baukasten. 100 % individuelle Entwicklung
                für deinen Erfolg.
              </p>

              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/kontak"
                  className="group inline-flex items-center gap-2 rounded-xl bg-white px-5 py-2.5 text-sm font-semibold text-black shadow transition hover:bg-white/90"
                >
                  Kontakt
                  <ArrowRight
                    size={16}
                    className="transition group-hover:translate-x-0.5"
                  />
                </Link>

                <Link
                  to="/unverbindliches-angebot"
                  className="inline-flex items-center rounded-xl border border-white/55 bg-[#0b2b40] px-5 py-2.5 text-sm font-semibold text-white/85 transition hover:bg-[#0b2b40]/90"
                >
                  Angebot einholen
                </Link>
              </div>
            </div>
          </div>

          {/* Right */}
          <div className="w-full lg:w-1/2">
            <div className="hero1-images">
              <div className="main-images ih">
                <div className="_relative reveal overflow-hidden image1">
                  <img
                    src={aiRobot}
                    alt="AI Robot"
                    decoding="async"
                    fetchpriority="high"
                  />
                </div>

                {/* Floating labels */}
                <div
                  style={{
                    backgroundColor: "#22C55E",
                    borderRadius: "30px",
                    fontSize: "14px",
                    color: "white",
                  }}
                  className="image-shape1 animate1 anim1 py-2 px-3 flex items-center gap-2 float-animation"
                >
                  <img loading="lazy" decoding="async" src={comp2_4} alt="" />
                  <span>Professionelle Entwicklung</span>
                </div>

                <div
                  style={{
                    backgroundColor: "#9333EA",
                    borderRadius: "30px",
                    fontSize: "14px",
                    color: "white",
                  }}
                  className="image-shape1 animate1 anim2 py-2 px-3 flex items-center gap-2 float-animation"
                >
                  <img loading="lazy" decoding="async" src={comp2_7} alt="" />
                  <span>SEO-Optimiert</span>
                </div>

                <div
                  style={{
                    backgroundColor: "#3B82F6",
                    borderRadius: "30px",
                    fontSize: "14px",
                    color: "white",
                  }}
                  className="image-shape1 animate1 anim3 py-2 px-3 flex items-center gap-2 float-animation"
                >
                  <img loading="lazy" decoding="async" src={comp2_3} alt="" />
                  <span>Für alle Endgeräte</span>
                </div>

                <div
                  style={{
                    backgroundColor: "#F6C42C",
                    borderRadius: "30px",
                    fontSize: "14px",
                    color: "black",
                  }}
                  className="image-shape1 animate1 anim4 py-2 px-3 flex items-center gap-2 float-animation"
                >
                  <img loading="lazy" decoding="async" src={comp3_2} alt="" />
                  <span>Individuelle Funktionen</span>
                </div>

                <div
                  style={{
                    backgroundColor: "white",
                    borderRadius: "30px",
                    fontSize: "14px",
                    color: "black",
                  }}
                  className="image-shape1 animate1 anim5 py-2 px-3 flex items-center gap-2 float-animation"
                >
                  <img loading="lazy" decoding="async" src={comp16_10} alt="" />
                  <div className="flex flex-col text-left">
                    <span>Ergebnis</span>
                    <span className="font-bold">ROI bestätigt</span>
                  </div>
                </div>

                {/* Stats Card */}
                <div
                  style={{
                    backgroundColor: "white",
                    borderRadius: "10px",
                  }}
                  className="image-shape2 animate3 p-3 text-left anim6 float-animation"
                >
                  <div className="flex justify-between items-center text-xs font-bold text-gray-500 uppercase">
                    <span className="mr-4">Umsatz gesteigert</span>
                    <span className="text-green-500 font-semibold">60%</span>
                  </div>

                  <h2 className="font-bold text-black my-1">65%</h2>

                  {[
                    ["Abläufe", "80%", "bg-blue-500"],
                    ["CRM-Integration", "65%", "bg-yellow-400"],
                    ["IT-Sicherheit", "90%", "bg-black"],
                  ].map(([label, value, color], i) => (
                    <div key={i}>
                      <div className="flex justify-between items-center text-[10px] font-bold text-gray-500 uppercase">
                        <span>{label}</span>
                        <span className="font-semibold">{value}</span>
                      </div>
                      <div className="w-full h-[2px] bg-gray-200 my-1">
                        <div
                          className={`${color} h-[2px]`}
                          style={{ width: value }}
                        />
                      </div>
                    </div>
                  ))}
                </div>

                <div
                  style={{
                    backgroundColor: "white",
                    borderRadius: "10px",
                  }}
                  className="image-shape2 animate3 flex flex-col justify-center items-center p-3 anim7 float-animation"
                >
                  <div className="flex items-center gap-2 text-xs font-bold uppercase text-gray-500 ">
                    <img loading="lazy" decoding="async" src={comp3_3} alt="" />
                    <span className="text-black font-semibold">
                      Performance-Optimierung
                    </span>
                  </div>
                  <img
                    loading="lazy"
                    decoding="async"
                    src={container1}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Counters */}
        <div className={` transition-all duration-700 hero1-counters mt-16`}>
          <div className="flex flex-wrap gap-y-6">
            {[counter1, counter2, counter3, counter4].map((img, i) => (
              <div key={i} className="w-1/2 md:w-1/4 flex items-center gap-3">
                <img loading="lazy" decoding="async" src={img} alt="" />
                <div className="single-counter uppercase">
                  <h3 className="text-gray-900 font-bold text-[22px] mb-0">
                    {["5+", "1348+", "25+", "10+"][i]}
                  </h3>
                  <p className="text-gray-500 text-xs font-bold mb-0">
                    {
                      [
                        "Jahre im Webdesign",
                        "Abgeschlossene Projekte",
                        "Interne Spezialisten",
                        "Auszeichnungen",
                      ][i]
                    }
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
